"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var lowerCase = require('lodash/lowerCase');

var PRODUCTS = require('../../constants');

function parseProductType() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    product_type: ''
  };
  var product_type = product.product_type;
  var new_product_type;

  switch (lowerCase(product_type)) {
    case 'announcements':
      new_product_type = PRODUCTS.WEDDING_POSTPONEMENT_ANNOUNCEMENTS;
      break;

    case 'covid letterpress invitations reprint':
      new_product_type = PRODUCTS.LETTERPRESS_WEDDING_INVITATION_REPRINTS_COVID;
      break;

    case 'covid invitations reprint':
      new_product_type = PRODUCTS.FLAT_WEDDING_INVITATION_REPRINTS_COVID;
      break;

    case 'booklet programs reprint':
      {
        var style = product.booklet_program_style || product.REPRINT_booklet_program_style;

        if (style.match(/deluxe/i)) {
          new_product_type = PRODUCTS.DELUXE_BOOKLET_WEDDING_PROGRAM_REPRINTS;
        } else if (style.match(/flat/i)) {
          new_product_type = PRODUCTS.FLAT_BOOKLET_WEDDING_PROGRAM_REPRINTS;
        } else {
          new_product_type = PRODUCTS.BASIC_BOOKLET_WEDDING_PROGRAM_REPRINTS;
        }

        break;
      }

    case 'programs reprint':
      {
        new_product_type = PRODUCTS.SQUARE_WEDDING_PROGRAM_REPRINTS;
        break;
      }

    case 'booklet programs':
    case 'booklet wedding programs':
      if (product.booklet_program_style.match(/deluxe/i)) {
        new_product_type = PRODUCTS.DELUXE_BOOKLET_WEDDING_PROGRAMS;
      } else if (product.booklet_program_style.match(/flat/i)) {
        new_product_type = PRODUCTS.FLAT_BOOKLET_WEDDING_PROGRAMS;
      } else {
        new_product_type = PRODUCTS.BASIC_BOOKLET_WEDDING_PROGRAMS;
      }

      break;

    case 'custom signs':
      new_product_type = PRODUCTS.CUSTOM_SIGNS;
      break;

    case 'favor tags':
      new_product_type = PRODUCTS.FAVOR_TAGS;
      break;

    case 'invitations':
    case 'invitation':
      if (parseBoolean(product.is_sample)) {
        new_product_type = PRODUCTS.CLASSIC_WEDDING_INVITATION_SAMPLES;
      } else {
        new_product_type = PRODUCTS.CLASSIC_WEDDING_INVITATIONS;
      }

      break;

    case 'letterpress invitations':
    case 'letterpress invitation':
    case 'letterpress invitations alt':
      if (parseBoolean(product.is_sample)) {
        new_product_type = PRODUCTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES;
      } else {
        new_product_type = PRODUCTS.LETTERPRESS_WEDDING_INVITATIONS;
      }

      break;

    case 'letterpress invitation reprint':
      new_product_type = PRODUCTS.LETTERPRESS_WEDDING_INVITATION_REPRINTS;
      break;

    case 'floral invitations':
      new_product_type = PRODUCTS.FLORAL_WEDDING_INVITATIONS;
      break;

    case 'letterpress std':
      new_product_type = PRODUCTS.LETTERPRESS_SAVE_THE_DATES;
      break;

    case 'letterpress std reprint':
    case 'letterpress save the date reprint':
    case 'letterpress save the date reprints':
    case 'lp save the date reprints':
      new_product_type = PRODUCTS.LETTERPRESS_SAVE_THE_DATE_REPRINTS;
      break;

    case 'menu':
    case 'menus':
      new_product_type = PRODUCTS.WEDDING_MENUS;
      break;

    case 'menu reprint':
      new_product_type = PRODUCTS.WEDDING_MENU_REPRINTS;
      break;

    case 'place card':
    case 'place cards':
      new_product_type = PRODUCTS.PLACE_CARDS;
      break;

    case 'place cards reprint':
      new_product_type = PRODUCTS.PLACE_CARD_REPRINTS;
      break;

    case 'programs':
    case 'wedding programs':
    case 'wedding program':
      new_product_type = PRODUCTS.SQUARE_WEDDING_PROGRAMS;
      break;

    case 'ribbon invitation':
    case 'ribbon invitations':
      new_product_type = PRODUCTS.RIBBON_WEDDING_INVITATIONS;
      break;

    case 'ribbon invitation reprint':
      new_product_type = PRODUCTS.RIBBON_WEDDING_INVITATION_REPRINTS;
      break;

    case 'save the dates':
      new_product_type = PRODUCTS.SAVE_THE_DATES;
      break;

    case 'save the date reprint':
      new_product_type = PRODUCTS.SAVE_THE_DATE_REPRINTS;
      break;

    case 'signs':
      if (product.name.match(/reserved/i)) {
        new_product_type = PRODUCTS.RESERVED_SIGNS;
      } else {
        new_product_type = PRODUCTS.WEDDING_SIGNS;
      }

      break;

    case 'welcome signs':
      new_product_type = PRODUCTS.WELCOME_SIGNS;
      break;

    case 'seating charts':
      new_product_type = PRODUCTS.SEATING_CHARTS;
      break;

    case 'silk sample':
      new_product_type = PRODUCTS.SILK_RIBBON_SAMPLES;
      break;

    case 'silk ribbon spool':
    case 'silk ribbon spools':
    case 'silk ribbon spool(s)':
      new_product_type = PRODUCTS.SILK_RIBBON;
      break;

    case 'table numbers':
    case 'table number':
      new_product_type = PRODUCTS.TABLE_NUMBERS;
      break;

    case 'thank you cards':
    case 'thank you card':
      new_product_type = PRODUCTS.THANK_YOU_CARDS;
      break;

    case 'thank you cards reprint':
      new_product_type = PRODUCTS.THANK_YOU_CARD_REPRINTS;
      break;

    case 'classic invitation reprint':
      new_product_type = PRODUCTS.CLASSIC_WEDDING_INVITATION_REPRINTS;
      break;

    case 'floral invitation reprint':
      new_product_type = PRODUCTS.FLORAL_WEDDING_INVITATION_REPRINTS;
      break;

    case 'vellum invitations':
      new_product_type = PRODUCTS.VELLUM_WEDDING_INVITATIONS;
      break;

    case 'vellum reprint':
      new_product_type = PRODUCTS.VELLUM_WEDDING_INVITATION_REPRINTS;
      break;

    case 'envelope reprint':
      new_product_type = PRODUCTS.ENVELOPE_REPRINTS;
      break;

    case 'wax seals':
      new_product_type = PRODUCTS.WAX_SEALS;
      break;

    case 'vellum jackets':
      new_product_type = PRODUCTS.VELLUM_JACKETS;
      break;

    default:
      new_product_type = PRODUCTS.CUSTOM_PRODUCT;
      break;
  }

  return new_product_type;
}

module.exports = parseProductType;